import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { MarketingService } from "../../services/marketing/marketing.service";
import { EoiService } from "../../services/eoi/eoi.service";
import { ProjectsService } from "../../services/projects/projects.service";
import { environment } from "../../../environments/environment";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { MatDialog } from "@angular/material";
import { EditEoiCustomerDialogComponent } from "../dialogs/edit-eoi-customer-dialog.component";
import {
  addMonths,
  differenceInCalendarMonths,
  format,
  getDate,
  lastDayOfMonth,
  parse,
  setDate,
} from "date-fns";
import { print_template } from "../../shared/helpers/print_helpers";
import { printEOIDetailsFile } from "./prints/eoi_print";
import { printRecipts } from "./prints/recipts";

@Component({
  selector: "app-eoi-view",
  templateUrl: "./eoi-view.component.html",
  styleUrls: ["./eoi-view.component.css"],
})
export class EoiViewComponent implements OnInit {
  eoi_id: any;
  eoi_details: any;
  userProfile: any;
  dataFromSearch: any;
  refundReason: any;
  refundReasons: any = [
    "Financial issue",
    "Personal issue",
    "Activate by Mistake",
    "Contract details",
    "Rejected Cheques",
  ];
  channel: any;
  lead_channel: any;
  lead_source: any;
  edit_lead_data = {
    lead_name: "",
    lead_nationality: "",
    lead_national_id: "",
    lead_address: "",
    lead_birthday: undefined,
    lead_district: "",
    lead_email: "",
    lead_arabic_name: "",
    lead_job_title: "",
    lead_issue_date: "",
    lead_workplace: "",
  };
  change_lead_data = {
    lead_id: "",
    lead_name: "",
    lead_phone: "",
    lead_nationality: "",
    lead_national_id: "",
    lead_address: "",
    lead_birthday: undefined,
    lead_district: "",
    lead_email: "",
    lead_arabic_name: "",
    lead_job_title: "",
    lead_issue_date: "",
    lead_workplace: "",
  };
  edit_eoi_data = {
    design_type: "",
    unit_type: "",
    unit_floor: "",
    beds_number: "",
    interested_area_from: "",
    interested_area_to: "",
    eoi_value: "",
    has_dad_room: false,
  };
  confirmation_date: any;
  chosenLeadID: any;
  leadArrSerach: any;
  chosenLead: any;
  chosenLeadReason: any;
  chosenLeadPhone: any;
  chosenLeadName: any;
  chosenLeadNationalityID: any;
  chosenLeadNationality: any;
  chosenLeadDistrict: any;
  chosenLeadIssueDate: any;
  chosenLeadCivilRegistery: any;
  chosenLeadBirthday: any;
  chosenLeadAddress: any;
  agent_in_charge: any;
  agents: any;
  divisionForm: any = {};
  deal_types: any = ["Direct", "In-Direct"];
  direct_option: any = ["Individual", "Ambassador"];
  deal_type: any;
  ambassadors: any;
  brokers: any;
  is_overseas: any;
  last_payment_type: any;
  last_payment_type_cheque_number: any;
  paymentForm: FormGroup;
  selling_price: any;
  price_precentage: any;
  percentage: any;
  reason: any;
  selling_price_in_modal: any;
  selling_date: any;
  signature_date: any;
  commentEoi: any;
  payment_types = [
    { name: "cash" },
    { name: "visa" },
    { name: "transfer" },
    { name: "cheque" },
  ];

  projects: any;

  unitFloors: any = [0, 1, 2, 3, 4, 5, 6, 7];
  unitTypes: any = [];
  designTypes: any = [];

  reservations: any = [
    {
      id: 12,
    },
    {
      id: 23,
    },
  ];

  payment_collections: any;
  store_banks: any;
  banks: any;
  add_cheque = {
    name: "",
    bank_id: "", // done
    store_status: "", // done
    cheque_number: "", // done
    amount: "", // done
    amount_received: "0", // done
    date: new Date(), // done
    type: 1,
    // fixed
    status: "under-collection",
    send_reminder: 1, // done
    print_status: 1, // done
  };

  // cheques book
  enable_edit_payment_collections = false;
  disableSavePaymentCollection = false;
  check_all = false;
  current_active_cheque: number;
  current_active_full_cheque: any;
  enableRemiderType: string;
  disableReminderType: string;
  chequeCollectType: any;
  chequeCollectCustomer: any;
  collect_type = "fully-collected";
  collection_date = "";
  chequeRejectType: any;
  developer_id: number;
  name_on_cheques: string;
  cheque_book_name: string;
  reminder_reason: string;
  uploadScannedChequeForm: FormGroup;
  reject_reason: any;
  reject_comment: string;
  cheque_amount: any;
  partially_method: any;
  partially_data: any;
  currencies_list = [];
  chequeRejectTypeFine: any;
  cheque_amount_fine = null;
  reject_reason_fine = null;
  reject_comment_fine = null;
  totalChequeBookAmount = 0;
  totalCDBAmount = 0;
  cdb_form = {
    amount: 0,
    date: "",
  };
  developers: any;
  chequeCollectCustomerFines: any;
  current_active_cheque_fine: number;
  partially_method_fines: any;
  partially_data_fines: any;
  cheque_amount_fines: any;
  currency_code: any = "EGP";
  collectModalSubmitting = false;
  DATE_FORMAT = "yyyy-MM-dd";
  add_fineModal = {
    submitting: false,
    eoi_id: "",
    payload: {
      amount: 0,
      num_days_late: 0,
      collection_cheque_id: null,
      fine_date: "",
    },
  };
  submitting_add_fine = false;
  cancelModalSubmitting = false;
  cancle_formdata = {
    early_payment_discount: 0,
    cancel_for: "",
    date: "",
    partially_method: "",
    cheque_number: "",
    store_status: null,
    bank_id: null,
    currency_code: "EGP",
  };
  filterForm: FormGroup;
  bank_id: any;
  store_status: any;
  file_name: any;
  filesForm: FormGroup;
  partially_methods = [
    "Cash",
    "Visa",
    "Transfer",
    "Cheque",
    "Commission Settlement",
    "Share Holder Settlement",
    "Vendor Settlement",
  ];
  eoi_details_id;

  edit_eoi_details_data = {
    unit_type: "",
    unit_floor: "",
    beds_number: "",
    has_nany_room: false,
    interested_area_from: "",
    interested_area_to: "",
    eoi_value: "",
    design_type: "",
    generic_type: "",
  };

  reservationDataFromSearch: any;
  reservationsArrSearch: any;
  chosen_reservation: any;
  chosenReservation: any;

  recall_request_ids: any;
  recall_request_reason: any;

  slip_type: any;
  deposit_amount: any;
  exchange_rate: any;
  commission_settlement_user_id: number;
  share_holder_name: string;
  slip_number: any;
  transaction_number: any;
  cheque_number: any;
  due_date: any;
  selectedDetails: any;
  file: any;

  incentive_users: any;
  generic_types: any;
  equivalent_in_currency: string;
  active_cheque_book_row: any;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private leadsService: LeadsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private marketingService: MarketingService,
    private eoiService: EoiService,
    private projectService: ProjectsService,
    private reservationService: ReservationService,
    private projectsService: ProjectsService,
    private dialog: MatDialog
  ) {
    this.userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
  }

  ngOnInit() {
    this.filterForm = this.fb.group({
      serial: [""],
      agent: [""],
      lead_name: [""],
    });
    this.filesForm = this.fb.group({
      receipt: [null, Validators.required],
      signed: [null, Validators.required],
      date: [null, Validators.required],
    });
    this.getdevelopers();
    this.getChequesTempaltes();
    this.getStoreBanks();
    this.getProjects();
    this.getChannels();
    this.getAmbassadors();
    this.getAllAgents();
    this.getBrokers();
    this.getAllCurrencies();
    // this.deal_type_change();
    // this.getPaymentTypes();
    this.activatedRoute.params.subscribe((res: any) => {
      console.log(res);
      this.eoi_id = res.id;
      this.getEoi(this.eoi_id);
      this.getPaymentCollection(this.eoi_id);
    });
    this.paymentForm = this.fb.group({
      percentage: [{ value: "", disabled: true }, Validators.required],
      payment_term_id: ["", Validators.required],
    });
  }

  getAllCurrencies() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getGenericTypes(project_id) {
    this.slimLoadingBarService.start();
    this.eoiService.getGenericTypes(project_id).subscribe(
      (data: any) => {
        this.generic_types = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  // getPaymentTypes() {
  //   this.slimLoadingBarService.start();
  //   this.eoiService.getPaymentTypes().subscribe(
  //     (res: any) => {
  //       this.payment_types = res;
  //       this.slimLoadingBarService.complete();
  //     },
  //     (err) => {
  //       this.slimLoadingBarService.reset();
  //     }
  //   );
  // }

  channels: any;
  leadSources = [];

  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getAllAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getPaymentCollection(eoi_id) {
    this.eoiService.getPaymentCollection(eoi_id).subscribe(
      (res: any) => {
        this.payment_collections = res.map((c) => {
          if (c.receipts) {
            c.collect_types = Array.from(
              new Set(c.receipts.map((r) => r.type_string))
            ).join(", ");
          }
          c.db_date = c.date;
          return c;
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getEoi(id?) {
    this.slimLoadingBarService.start();
    this.eoiService.getEoi(id || this.eoi_id).subscribe(
      (res: any) => {
        this.eoi_details = {
          ...res,
          total_down_payment: "",
        };
        this.slip_type = res.payment_type_int;
        this.cheque_number = res.cheque_number;
        // this.agent_in_charge = res.agent_in_charge;
        if (res.agent_in_charge)
          this.agent_in_charge = this.agents.find(
            (a) => a.id == res.agent_in_charge
          );
        this.getGenericTypes(res.project.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  //Operationstab functions
  refundAdminDeclineModalSubmit(modal) {
    let payload = {
      refund_reason: this.refundReason,
    };
    if (!this.refundReason)
      swal("You have to provide a refund reason", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.eoiService
        .refundEOI(this.eoi_details.id, JSON.stringify(payload))
        .subscribe(
          (data) => {
            swal("Woohoo!", "Refunded Successfully!", "success");
            this.getEoi(this.eoi_id);
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  // accountantApprove() {
  //   swal({
  //     title: "Are you sure?",
  //     text: "You will approve the EOI!",
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Approve it!",
  //     cancelButtonText: "No, keep it",
  //   }).then((result) => {
  //     if (result.value) {
  //       this.eoiService
  //         .approveEoi(this.eoi_details.id)
  //         .subscribe((res: any) => {
  //           swal("Woohoo!", "Approved Successfully!", "success");
  //           this.getEoi(this.eoi_id);
  //         });
  //     } else if (result.dismiss) {
  //       swal("Cancelled", "", "error");
  //     }
  //   });
  // }

  onTypeChange(type) {
    switch (type) {
      case "1":
        this.cheque_number = undefined;
        this.due_date = undefined;
        break;
      case "2":
      case "3":
        this.due_date = undefined;
        break;
      case "4":
        this.store_status = undefined;
        this.collection_date = undefined;
        break;
    }
  }

  accountantApprove(modal) {
    console.log(this.slip_type);
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    if (this.slip_type == "5") {
      if (!this.commission_settlement_user_id) {
        swal(
          "Error",
          "Missing data, commission settlement user is a mandatory",
          "error"
        );
        return;
      }
    }
    if (this.slip_type == "6") {
      if (!this.share_holder_name) {
        swal("Error", "Missing data, share holder is a mandatory", "error");
        return;
      }
    }
    if (this.slip_type === "1") {
      if (!this.collection_date) {
        console.log("1");
        console.log(this.collection_date);
        // console.log(this.slip_number);
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return;
      }
    }
    if (this.slip_type === "2" || this.slip_type === "3") {
      console.log(this.transaction_number);
      console.log(this.bank_id);
      console.log(this.store_status);
      console.log(this.collection_date);
      // console.log(this.slip_number);
      if (
        !this.transaction_number ||
        !this.store_status ||
        !this.collection_date
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return;
      }
    }
    if (this.slip_type === "4") {
      console.log(this.cheque_number);
      console.log(this.bank_id);
      console.log(this.due_date);
      // console.log(this.slip_number);
      if (!this.cheque_number || !this.bank_id || !this.due_date) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return;
      }
    }
    let payload: any = {
      // slip_number: this.slip_number,
      type: this.slip_type,
      cheque_number: this.cheque_number,
      currency_code: this.currency_code,
      exchange_rate: this.exchange_rate,
      transaction_number: this.transaction_number,
    };
    if (this.file) {
      payload.file = this.file;
      payload.file_name = this.file_name;
    }
    if (this.slip_type == 4 || this.slip_type == 2 || this.slip_type == 3)
      payload.store_status = this.store_status;
    if (this.slip_type == 4) {
      payload.due_date = this.due_date;
      payload.bank_id = this.bank_id;
    } else {
      payload.collection_date = this.collection_date;
    }
    if (this.slip_type == 5) {
      payload.commission_settlement_user_id =
        this.commission_settlement_user_id;
    }
    if (this.slip_type == 6) {
      payload.share_holder_name = this.share_holder_name;
    }
    console.log(payload);
    this.slimLoadingBarService.start();
    this.eoiService.approveEoi(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi();
        this.getPaymentCollection(this.eoi_details.id);
        this.deposit_amount = null;
        this.slimLoadingBarService.complete();
        modal.close();
        swal("success", "Approve successfully", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  cancel() {
    swal({
      title: "Are you sure?",
      text: "You will Cancel the EOI!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.eoiService.cancelEoi(this.eoi_details.id).subscribe((res: any) => {
          swal("Woohoo!", "Cancelled Successfully!", "success");
          this.getEoi(this.eoi_id);
        });
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  //customer/unit info tab functions
  downloadEoiDocument() {
    this.slimLoadingBarService.start();
    this.eoiService.downloadEoiDocument(this.eoi_details.id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  printEOI() {
    print_template(
      printEOIDetailsFile,
      this.eoi_details,
      this.payment_collections
    );
  }

  submitConfirmationDateModal(eoiDetails, modal) {
    if (!this.confirmation_date)
      swal("Confirmation date can not be empty", "", "error");
    else {
      let data = {
        confirmation_date: this.confirmation_date,
      };
      this.slimLoadingBarService.start();
      this.eoiService.changeConfirmationDate(eoiDetails.id, data).subscribe(
        (data) => {
          modal.close();
          swal("Confirmation date changed successfully", "", "success");
          this.getEoi(eoiDetails.id);
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  adminDecline(eoiId, modal) {
    swal({
      title: "Are you sure?",
      text: "You will decline the eoi!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        if (this.eoi_details.authorization.can_refund_reason == 1) {
          modal.open();
          console.log("success");
        } else {
          console.log("err");
        }
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  swalDelete(eoiId) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this eoi!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.eoiService.deleteEoi(eoiId).subscribe(
          (data) => {
            this.slimLoadingBarService.complete();
            swal("Deleted!", "Eoi has been deleted.", "success");
            this.router.navigateByUrl("/pages/eoi-table");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  reAssignClientSubmit(eoi, modal) {
    if (!this.chosenLeadID)
      swal(
        "Lead ID can not be empty",
        "click on get info button to get the lead id.",
        "error"
      );
    else if (!this.chosenLeadPhone)
      swal("Client Phone can not be empty", "", "error");
    else if (!this.chosenLeadName)
      swal("Client Name can not be empty", "", "error");
    else if (!this.chosenLeadReason)
      swal("Reason can not be empty", "", "error");
    else if (!this.chosenLeadNationalityID)
      swal("Client Nationality can not be empty", "", "error");
    else if (!this.chosenLeadNationality)
      swal("Client Nationality ID can not be empty", "", "error");
    else if (!this.chosenLeadDistrict)
      swal("Client Lead District can not be empty", "", "error");
    else if (!this.chosenLeadIssueDate)
      swal("Client Issue Date can not be empty", "", "error");
    else if (!this.chosenLeadCivilRegistery)
      swal("Client Civil Registery can not be empty", "", "error");
    else if (!this.chosenLeadBirthday)
      swal("Client Birthday can not be empty", "", "error");
    else if (!this.chosenLeadAddress)
      swal("Client Address can not be empty", "", "error");
    else {
      //call the back end point
      let data = {
        lead_id: this.chosenLeadID,
        eoi_id: eoi.id,
        reason: this.chosenLeadReason,
        lead_name: this.chosenLeadName,
        lead_phone: this.chosenLeadPhone,
        lead_national_id: this.chosenLeadNationalityID,
        lead_nationality: this.chosenLeadNationality,
        lead_district: this.chosenLeadDistrict,
        lead_issue_date: this.chosenLeadIssueDate,
        lead_civil_registry: this.chosenLeadCivilRegistery,
        lead_birthday: this.chosenLeadBirthday,
        lead_address: this.chosenLeadAddress,
      };
      this.slimLoadingBarService.start();
      this.eoiService.reAssignToLead(data).subscribe(
        (res) => {
          this.getEoi(this.eoi_id);
          swal("Re-assign eoi to client successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  openEditLead() {
    // Prepare customer data from eoi_details
    const customerData = {
      lead_name: this.eoi_details.lead_name,
      lead_phone: this.eoi_details.lead_phone,
      lead_code: this.eoi_details.lead_code,
      lead_phone_without_code: this.eoi_details.lead_phone_without_code,
      lead_home_phone: this.eoi_details.lead_home_phone,
      lead_home_code: this.eoi_details.lead_home_code,
      lead_home_phone_without_code: this.eoi_details.lead_home_phone_without_code,
      lead_other_phone: this.eoi_details.lead_other_phone,
      lead_other_code: this.eoi_details.lead_other_code,
      lead_other_phone_without_code: this.eoi_details.lead_other_phone_without_code,
      lead_email: this.eoi_details.lead_email,
      lead_national_id: this.eoi_details.lead_national_id,
      lead_nationality: this.eoi_details.lead_nationality,
      lead_birthday: this.eoi_details.lead_birthday ? new Date(this.eoi_details.lead_birthday).toJSON().split("T")[0] : null,
      lead_address: this.eoi_details.lead_address,
      lead_district: this.eoi_details.lead_district,
      lead_arabic_name: this.eoi_details.lead_arabic_name,
      lead_issue_date: this.eoi_details.lead_issue_date ? new Date(this.eoi_details.lead_issue_date).toJSON().split("T")[0] : null,
      lead_job_title: this.eoi_details.lead_job_title,
      lead_workplace: this.eoi_details.lead_workplace,
      lead_work_address: this.eoi_details.lead_work_address,
      lead_fax_number: this.eoi_details.lead_fax_number,
      lead_marital_status: this.eoi_details.lead_marital_status,
    };

    const dialogRef = this.dialog.open(EditEoiCustomerDialogComponent, {
      width: '60vw',
      height: '95vh',
      data: {
        eoi_id: this.eoi_details.id,
        customer: customerData,
        title: 'Edit Customer Info'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh EOI details to get updated data
        this.getEoi();
      }
    });
  }

  openEditEOi() {
    this.edit_eoi_data = {
      design_type: this.eoi_details.design_type,
      unit_type: this.eoi_details.unit_type,
      unit_floor: this.eoi_details.unit_floor,
      beds_number: this.eoi_details.beds_number,
      interested_area_from: this.eoi_details.interested_area_from,
      interested_area_to: this.eoi_details.interested_area_to,
      eoi_value: this.eoi_details.eoi_value,
      has_dad_room: this.eoi_details.has_dad_room === "True",
    };

    this.getUnitTypes(this.eoi_details.project_id);
    this.getdesignTypes(this.eoi_details.project_id);
  }

  getUnitTypes(project_id) {
    this.slimLoadingBarService.start();
    this.unitTypes = [];

    this.projectService.getUnitTypes(project_id).subscribe(
      (data) => {
        this.unitTypes = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }
  getdesignTypes(project_id) {
    this.slimLoadingBarService.start();
    this.designTypes = [];

    this.projectService.getDesignTypes(project_id).subscribe(
      (data) => {
        this.designTypes = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  editLeadModalSubmit(modal) {
    let payload = this.edit_lead_data;
    this.slimLoadingBarService.start();
    this.eoiService.editLeadInEoi(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi(this.eoi_id);
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  editEoiModalSubmit(modal) {
    let payload = this.edit_eoi_data;
    this.slimLoadingBarService.start();
    this.eoiService.editEoiInfo(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi(this.eoi_id);
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  changeChannelAndSourceModalSubmit(modal) {
    let data = {
      lead_channel: this.lead_channel,
      lead_source: this.lead_source,
    };
    console.log(data);
    this.eoi_details.lead_channel = this.lead_channel;
    this.eoi_details.lead_source = this.lead_source;
    modal.close();
    this.slimLoadingBarService.start();
    this.eoiService.changeChannelSource(this.eoi_details.id, data).subscribe(
      (res: any) => {
        this.getEoi(this.eoi_id);
        this.slimLoadingBarService.complete();
        swal("success", "changed channel and source successfully", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  channelChange(change) {
    if (change) {
      this.divisionForm.lead_source = -1;
    }
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((e) => {
          if (e.name == this.divisionForm.deal_type) {
            this.leadSources = [];
            if (change) {
              this.divisionForm.deal_category = "";
              this.divisionForm.deal_source = "";
            }
            this.leadSources = e.sources;
            if (change && e.name != "Direct") {
              if (this.divisionForm.broker_id) {
                this.divisionForm.broker_id = null;
              } else if (this.divisionForm.ambassador_id) {
                this.divisionForm.ambassador_id = null;
              }
            }
          }
        });
      });
    } else {
      this.channels.forEach((e) => {
        if (e.name == this.divisionForm.deal_type) {
          this.leadSources = [];
          if (change) {
            this.divisionForm.deal_category = "";
            this.divisionForm.deal_source = "";
          }
          this.leadSources = e.sources;
          if (change && e.name != "Direct") {
            if (this.divisionForm.broker_id) {
              this.divisionForm.broker_id = null;
            } else if (this.divisionForm.ambassador_id) {
              this.divisionForm.ambassador_id = null;
            }
          }
        }
      });
    }
  }

  reactivateEoi() {
    swal({
      title: "Are you sure?",
      text: "Re-activate this Eoi!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.eoiService.reactivateEoi(this.eoi_details.id).subscribe(
          (data) => {
            this.getEoi(this.eoi_details.id);
            swal("Woohoo!", "Re-activated succesfully!", "success");
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          },
          () => this.slimLoadingBarService.complete()
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .post(`${baseUrl}leads/search`, JSON.stringify(data))
        .map((res: any) => {
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.leadArrSerach = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.leadArrSerach.push(`${e.name} / ${e.id}`);
            });
            return this.leadArrSerach;
          }
        });
    } else {
      return Observable.of([]);
    }
  };
  onLoadLeadForChange(chosenLead) {
    console.log(chosenLead);
    if (!chosenLead) {
      swal("Lead name can not be empty!");
    } else {
      if (this.dataFromSearch.length == 0) {
        swal("No Lead with that name.");
      } else {
        console.log("Choosen lead", chosenLead);

        let found = false;
        this.dataFromSearch.forEach((element) => {
          const nameArr = chosenLead.replace(/\s/g, "").split("/");
          const leadId = nameArr[nameArr.length - 1];
          if (element.id == leadId) {
            found = true;
            // this.eois = element.project.eois;
            this.change_lead_data = {
              lead_id: element.id,
              lead_name: element.name,
              lead_arabic_name: "",
              lead_email: element.email,
              lead_phone: element.phone,
              lead_district: "",
              lead_nationality: "",
              lead_national_id: element.national_num,
              lead_issue_date: element.national_issue_date,
              lead_address: element.address,
              lead_birthday: element.date_of_birth,
              lead_job_title: element.job_title,
              lead_workplace: element.workpalce,
            };
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }
  changeLeadModalSubmit(modal) {
    let payload = this.change_lead_data;
    this.slimLoadingBarService.start();
    this.eoiService.changeLead(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi(this.eoi_id);
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
  //dealTypeTab functions starts here

  onAgentInChargeSelected(event) {
    console.log(this.agent_in_charge);
    let payload = {
      agent_in_charge: this.agent_in_charge ? this.agent_in_charge.id : "",
    };
    this.eoiService.changeAgentInCharge(this.eoi_details.id, payload).subscribe(
      (res) => {
        swal("Success", "Agent in charge changed successfully", "success");
        this.getEoi();
      },
      (err) => {
        console.log(err);
        this.agent_in_charge = undefined;
      }
    );
  }

  deal_type_change() {
    this.divisionForm.get("deal_type").valueChanges.subscribe((val) => {
      console.log(val);
      if (val == "Direct") {
        if (this.divisionForm.get("broker_id"))
          this.divisionForm.removeControl("broker_id");
        this.divisionForm.addControl(
          "deal_category",
          new FormControl("", Validators.required)
        );
        this.division_type_change();
        console.log(this.divisionForm.value);
      } else if (val == "In-Direct") {
        console.log(val);
        if (this.divisionForm.get("deal_category"))
          this.divisionForm.removeControl("deal_category");
        if (this.divisionForm.get("ambassador_id"))
          this.divisionForm.removeControl("ambassador_id");
        this.divisionForm.addControl(
          "broker_id",
          new FormControl(undefined, Validators.required)
        );
      }
    });
  }

  division_type_change() {
    console.log("division_type_change changed");
    this.divisionForm.get("deal_category").valueChanges.subscribe((val) => {
      if (val == "Ambassador") {
        console.log("Ambassador");
        this.divisionForm.addControl(
          "ambassador_id",
          new FormControl("", Validators.required)
        );
      } else if (val == "Individual") {
        console.log("Individual");
        // if (this.divisionForm.removeControl('ambassador_id'))
        //   this.divisionForm.removeControl('ambassador_id');
      }
    });
  }

  divisionModalSubmit(modal) {
    let payload = Object.assign({}, this.divisionForm);

    payload.eoi_id = this.eoi_details.id;
    if (this.divisionForm.deal_type == "Direct") {
      this.divisionForm.ambassador_id = "";
      this.divisionForm.broker_id = "";
    } else {
      if (this.divisionForm.deal_source == "Broker") {
        this.divisionForm.ambassador_id = "";
      } else if (this.divisionForm.deal_source == "Ambassador") {
        this.divisionForm.broker_id = "";
      }
    }

    this.slimLoadingBarService.start();
    this.eoiService.changeDealType(payload).subscribe(
      (res) => {
        swal("Division changes successfully", "", "success");
        modal.close();
        this.getEoi();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getIncentiveUsers(broker_id: number) {
    this.userService.get_incentive_users(broker_id).subscribe(
      (res: any) => {
        this.incentive_users = res;
        console.log(this.agents);
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAmbassadors() {
    this.slimLoadingBarService.start();
    let params = {
      paginate: false,
    };
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = data;
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  overseasModalSubmit(modal) {
    let payload = {
      is_overseas: this.is_overseas,
    };
    this.slimLoadingBarService.start();
    this.eoiService.changeOverseas(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi();
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  //accountant information tab funcitons starts here
  cheque_recieved(eoi_id) {
    swal({
      title: "Are you sure?",
      text: "cheque Recieved!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.eoiService.cheque_recieved(eoi_id).subscribe(
          (data) => {
            this.getEoi();
            swal("Woohoo!", "cheque Recieved succesfully!", "success");
          },
          (err) => console.log(err),
          () => this.slimLoadingBarService.complete()
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  paymentTypeSubmit(modal) {
    let payload = {
      payment_type: this.last_payment_type,
      cheque_number: this.last_payment_type_cheque_number,
    };
    this.slimLoadingBarService.start();
    this.eoiService.changePaymentType(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getEoi();
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  submiteditSellingPriceModal(eoi, modal) {
    this.reason = this.reason;
    if (!this.reason) swal("reason can not be empty", "", "error");
    else {
      let data = {
        eoi_value: this.selling_price_in_modal,
        reason: this.reason,
      };
      this.slimLoadingBarService.start();
      this.eoiService.editSellingPrice(eoi.id, data).subscribe(
        (data: any) => {
          swal("Selling price changes successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  submitChangeSellingDateModal(eoi, modal) {
    if (!this.selling_date) swal("EOI date can not be empty", "", "error");
    else {
      let data = {
        selling_date: this.selling_date,
      };
      this.slimLoadingBarService.start();
      this.eoiService.changeSellingDate(eoi.id, data).subscribe(
        (data) => {
          modal.close();
          swal("EOI date changed successfully", "", "success");
          this.getEoi();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  submitCommentModal(eoi_id, modal) {
    if (!this.commentEoi) swal("Error", "Comment can not be empty", "error");
    else {
      this.slimLoadingBarService.start();
      this.eoiService.addEoiComment(eoi_id, this.commentEoi).subscribe(
        (data) => {
          modal.close();
          this.getEoi();
          swal("Woohoo!", "Comment have added succesfully!", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  //PC info Tab starts here
  chosenAgent: any;
  filterAgentByWordText: any;
  arrSearch: any;

  submitAssignModal(res_id, modal) {
    this.slimLoadingBarService.start();
    if (!this.chosenAgent)
      swal("You must chose a property consultant", "", "error");
    else {
      this.eoiService.assignToLead(res_id, this.chosenAgent.id).subscribe(
        (data) => {
          console.log(data);
          modal.close();
          swal("Woohoo!", "Assigned to user successfully!", "success");
          this.getEoi();
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
    }
  }

  submitAssignToAgentModal(res_id, modal) {
    console.log(this.selectedDetails);
    this.slimLoadingBarService.start();
    if (!this.chosenAgent)
      swal("You must chose a property consultant", "", "error");
    else {
      this.eoiService
        .assignToAgent(this.selectedDetails, this.chosenAgent.id)
        .subscribe(
          (data) => {
            console.log(data);
            modal.close();
            swal("Woohoo!", "Assigned to user successfully!", "success");
            this.getEoi();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  filterLeadObservable = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    console.log(baseUrl);
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            console.log(this.arrSearch);
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  valueChanged(event) {
    this.dataFromSearch.forEach((e) => {
      if (e.name == event) this.chosenAgent = e;
    });
  }

  redirectToLeadDetails(leadId) {
    if (!isNaN(leadId)) {
      this.router.navigate([`/pages/leads/${leadId}`]);
    }
    return;
  }

  getProjects() {
    this.projectService
      .getProjects({ is_select_form: true })
      .subscribe((res: any) => {
        this.projects = res;
      });
  }

  onProjectChange(event) {
    console.log(this.eoi_details.project_id);
    let payload = {
      project_id: this.eoi_details.project_id,
    };
    this.slimLoadingBarService.start();
    this.eoiService.changeProject(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        swal("Success", "Changed Project Successfully", "success");
        this.getEoi();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  onReservationLink(event) {
    console.log(this.eoi_details.reservation_id);
    let payload = {
      reservation_id: this.eoi_details.reservation_id,
    };
    this.slimLoadingBarService.start();
    this.eoiService
      .changeLinkedReservationEOI(this.eoi_details.id, payload)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          swal("Success", "Changed Linked Reservation Successfully", "success");
          this.getEoi();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  printReceipt() {
    this.slimLoadingBarService.start();
    this.eoiService.printReceipt(this.eoi_details.id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  getStoreBanks() {
    this.slimLoadingBarService.start();
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks = data;
        console.log(this.banks);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  addChequeBook(modal) {
    this.slimLoadingBarService.start();
    this.eoiService.addCheque(this.eoi_details.id, this.add_cheque).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        modal.close();
        swal("Success", "Cheque added successfully", "success");
        this.getPaymentCollection(this.eoi_details.id);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  getChequesTempaltes() {
    this.projectsService.getBanks().subscribe(
      (res: any) => {
        this.banks = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  enablePaymentCollectionEdit(enable_or_disable: boolean): void {
    this.enable_edit_payment_collections = enable_or_disable;
    if (enable_or_disable) {
      this.onChequeAmountChanged();
    } else {
      this.getPaymentCollection(this.eoi_details.id);
    }
  }

  onChequeAmountChanged() {
    this.totalChequeBookAmount = 0;
    this.totalCDBAmount = 0;
    this.payment_collections.map((c) => {
      if (c.status === "cancelled") return;
      if (
        c.installment_type == "Down Payment" ||
        c.installment_type == "Installment" ||
        c.installment_type == "Eoi"
      )
        this.totalChequeBookAmount += +c.amount + c.early_payment_discount || 0;
      else if (c.installment_type == "CDB")
        this.totalCDBAmount += +c.amount || 0;
    }, 0);
  }

  savePaymnetcollection() {
    this.disableSavePaymentCollection = true;
    this.slimLoadingBarService.start();
    this.projectsService
      .updateChequeBook(0, this.payment_collections)
      .subscribe(
        (res: any) => {
          this.disableSavePaymentCollection = false;
          this.enablePaymentCollectionEdit(false);
          this.getEoi();
          swal("Success", "", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.disableSavePaymentCollection = false;
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  // Add CDB Form
  openaddCDB() {
    this.cdb_form = {
      amount: 0,
      date: "",
    };
  }

  submitaddCDB(modal) {
    this.slimLoadingBarService.start();
    this.eoiService
      .addCDB(this.eoi_details.id, this.cdb_form)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.getPaymentCollection(this.eoi_details.id);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }

  printPaymentsPdf() {
    this.slimLoadingBarService.start();
    this.eoiService.printPaymentsPdf(this.eoi_details.id).subscribe(
      (res: any) => {
        this.projectsService.printHtml(res.url);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        console.log(err);
      }
    );
  }

  submitPrintPaymentCollectioModal(modal) {
    const payload = {
      developer_id: +this.developer_id,
      cheque_book_name: this.cheque_book_name,
      name_on_cheques: this.name_on_cheques,
    };
    this.slimLoadingBarService.start();
    this.eoiService.printChequBook(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        window.open(res.url);
        swal("Success", "", "success");
        this.slimLoadingBarService.complete();
        modal.close();
        this.getEoi();
        modal.close();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        console.log(this.developers);
      },
      (err) => {},
      () => this.slimLoadingBarService.complete()
    );
  }

  // reminder
  oOpenEnableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.enableRemiderType = type;
    else this.enableRemiderType = null;
    modal.open();
  }

  oOpenDisableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.disableReminderType = type;
    else this.disableReminderType = null;
    modal.open();
  }

  enableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenEnableReminder(null, modal, "multiple");
    }
  }

  disableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenDisableReminder(null, modal, "multiple");
    }
  }

  // collect
  onOpenCollectCheque(row, modal, type?) {
    if (row) this.current_active_cheque = row.id;
    if (type) this.chequeCollectType = type;
    else this.chequeCollectType = null;
    this.partially_method = row.partially_method;
    this.collection_date = row.collection_date;
    this.partially_data = row.cheque_number;
    this.bank_id = row.bank_id;
    this.collect_type = row.collect_type;
    this.cheque_amount = row.amount;
    console.log(this.chequeCollectType);
    this.active_cheque_book_row = row;
    modal.open();
  }

  collectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenCollectCheque(null, modal, "multiple");
    }
  }

  onOpenRejectCheque(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.chequeRejectType = type;
    else this.chequeRejectType = null;
    console.log(this.chequeRejectType);
    modal.open();
  }

  // reject
  onOpenRejectChequeFine(id, modal, type?) {
    if (id) this.current_active_cheque_fine = id;
    if (type) this.chequeRejectTypeFine = type;
    else this.chequeRejectTypeFine = null;
    console.log(this.chequeRejectTypeFine);
    modal.open();
  }

  rejectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenRejectCheque(null, modal, "multiple");
    }
  }

  submitDisableReminder(modal) {
    let payload;
    if (this.disableReminderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.eoiService
      .enableOrDisableReminderCheque(this.eoi_details.id, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getEoi();
          this.onCheckAllToggle(false);
          this.disableReminderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  onCheckAllToggle(event) {
    this.check_all = event;
    this.payment_collections.forEach((e) => {
      if (this.check_all) {
        e.checked = true;
      } else {
        e.checked = false;
      }
    });
  }

  submitEnableReminder(modal) {
    let payload;
    if (this.enableRemiderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.eoiService
      .enableOrDisableReminderCheque(this.eoi_details.id, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getEoi();
          this.onCheckAllToggle(false);
          this.enableRemiderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  onFileSelect(event) {
    let reader = new FileReader();
    this.file_name = null;
    this.file = null;
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.file_name = file.name;
        this.file = (reader.result as any).split(",")[1];
      };
    }
  }

  submitCollectCheque(modal) {
    if (this.collectModalSubmitting) return;
    let payload;
    if (this.chequeCollectType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
      };
      if (this.collect_type == "partially-collected") {
        payload.amount_received = this.cheque_amount;
        if (payload.partially_method == "3") {
          payload.partially_data = this.partially_data;
        }
      }
    }
    if (this.partially_method == "2" || this.partially_method == "3") {
      if (this.file) {
        payload.file = this.file;
        payload.file_name = this.file_name;
      } else {
        swal("error", "File Is Required", "error");
        return;
      }
    }

    if (this.partially_method === "2" || this.partially_method === "3") {
      if (this.transaction_number) {
        payload.transaction_number = this.transaction_number;
      } else {
        swal("error", "Transaction Number Is Required", "error");
        return;
      }
    }

    if (this.partially_method == "4") {
      payload.bank_id = this.bank_id;
      if (this.partially_data) {
        payload.partially_data = this.partially_data;
      } else {
        swal("error", "Cheque Number is required", "error");
        return;
      }
    }

    if (
      this.partially_method == "1" ||
      this.partially_method == "2" ||
      this.partially_method == "3" ||
      this.partially_method == "4"
    ) {
      if (this.store_status) {
        payload.store_status = this.store_status;
      } else {
        swal("error", "Location is required", "error");
        return;
      }
    }

    if (
      this.partially_method == "2" ||
      this.partially_method == "3" ||
      this.partially_method == "4"
    ) {
      if (this.bank_id) {
        payload.bank_id = this.bank_id;
      } else {
        swal("error", "Customer Bank is required", "error");
        return;
      }
    }
    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.eoiService
      .collectCheque(this.eoi_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getPaymentCollection(this.eoi_details.id);
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type = null;
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.partially_method = null;
          this.partially_data = null;
          this.collection_date = "";
          this.chequeCollectCustomer = "";
          this.getEoi();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  submitRejectCheque(modal) {
    let payload;
    if (this.chequeRejectType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        status: "bounced",
        reject_reason: this.reject_reason,
        reject_comment:
          this.reject_reason == "other" ? this.reject_comment : "",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: "bounced",
        reject_reason: this.reject_reason,
        reject_comment:
          this.reject_reason == "other" ? this.reject_comment : "",
      };
    }
    this.slimLoadingBarService.start();
    this.eoiService.collectCheque(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        modal.close();
        this.current_active_cheque = null;
        this.cheque_amount = null;
        this.reject_reason = null;
        this.reject_comment = null;
        this.getEoi();
        this.onCheckAllToggle(false);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  printSelectedCheque() {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    const payload = {
      ids: selectedCheques.map((cheque) => cheque.id),
    };
    this.eoiService.printCheques(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        const WindowPrt = window.open(res.url, "", "");
        WindowPrt.focus();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].bank_id =
          this.payment_collections[index].bank_id;
      }
    });
  }
  onStoreBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].store_status =
          this.payment_collections[index].store_status;
      }
    });
  }
  onPartiallyMethodBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].partially_method =
          this.payment_collections[index].partially_method;
      }
    });
  }

  onChequeNumberBlur(event, index) {
    if (typeof this.payment_collections[index].cheque_number == "number") {
      this.payment_collections.forEach((payment, payment_index) => {
        if (payment.status === "cancelled") return;
        if (payment_index > index) {
          this.payment_collections[payment_index].cheque_number =
            this.payment_collections[payment_index - 1].cheque_number + 1;
        }
      });
    }
  }

  onChequeDateChanged(event, index) {
    const date = parse(
      this.payment_collections[index].date,
      this.DATE_FORMAT,
      new Date()
    );
    const db_date = parse(
      this.payment_collections[index].db_date,
      this.DATE_FORMAT,
      new Date()
    );

    let day_of_month = getDate(date);
    console.log(day_of_month);

    const monthsDiff = differenceInCalendarMonths(date, db_date);
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        let current_date = parse(payment.db_date, this.DATE_FORMAT, new Date());
        current_date = setDate(current_date, 1);
        current_date = addMonths(current_date, monthsDiff);

        let last_day_of_month = getDate(lastDayOfMonth(current_date));

        current_date = setDate(
          current_date,
          day_of_month > last_day_of_month ? last_day_of_month : day_of_month
        );

        payment.date = format(current_date, this.DATE_FORMAT);
      }
    });
  }

  openDelayFineModal(modal, cheque) {
    this.add_fineModal = {
      submitting: false,
      eoi_id: cheque.eoi_id,
      payload: {
        amount: 0,
        num_days_late: 0,
        collection_cheque_id: cheque.id,
        fine_date: "",
      },
    };
    modal.open();
  }

  onOpenCancelCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  submitCancelCheque(modal) {
    if (this.cancelModalSubmitting) return;

    let payload;
    if (this.cancle_formdata.cancel_for === "under-collection") {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
        early_payment_discount: this.cancle_formdata.early_payment_discount,
        date: this.cancle_formdata.date,
        partially_method: this.cancle_formdata.partially_method,
        cheque_number: this.cancle_formdata.cheque_number,
        currency_code: this.cancle_formdata.currency_code,
        bank_id: this.cancle_formdata.bank_id,
        store_status: this.cancle_formdata.store_status,
      };
    }

    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.eoiService
      .collectCheque(0, payload, this.filterForm.value)
      .subscribe(
        (res: any) => {
          this.cancle_formdata = {
            early_payment_discount: 0,
            cancel_for: "",
            date: "",
            partially_method: "",
            cheque_number: "",
            store_status: null,
            bank_id: null,
            currency_code: "EGP",
          };
          this.current_active_cheque = null;
          modal.close();
          this.getEoi();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  printChequeModalSubmit() {
    if (this.bank_id) {
      const payload = {
        cheque_template_id: this.bank_id,
      };
      this.slimLoadingBarService.start();
      this.projectsService
        .printBankCheques(this.eoi_details.id, payload)
        .subscribe(
          (res: any) => {
            this.projectsService.printHtml(res.url);
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.slimLoadingBarService.reset();
            console.log(err);
          }
        );
    }
  }

  printReciptModalSubmit(id) {
    this.slimLoadingBarService.start();
    this.projectsService.printRecipt(id).subscribe(
      (res: any) => {
        console.log(res);
        this.projectsService.printHtml(res);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        console.log(err);
      }
    );
  }

  printCheque(id) {
    const payload = {
      ids: [id],
    };
    this.eoiService.printCheques(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        const WindowPrt = window.open(res.url, "", "");
        WindowPrt.focus();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  showCheque(id) {
    const payload = {
      ids: [id],
      print_status: 1,
    };
    this.eoiService.hideOrShowCheque(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getPaymentCollection(this.eoi_details.id);
        this.slimLoadingBarService.complete();
        swal("success", "Show successfully", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  hideCheque(id) {
    const payload = {
      ids: [id],
      print_status: 0,
    };
    this.eoiService.hideOrShowCheque(this.eoi_details.id, payload).subscribe(
      (res: any) => {
        this.getPaymentCollection(this.eoi_details.id);
        swal("success", "Hide successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  deleteCheque(id) {
    let payload = {
      ids: [id],
    };
    this.slimLoadingBarService.start();
    this.eoiService.deleteCheque(payload).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        swal("success", "Cheque deleted successfully", "success");
        this.getPaymentCollection(this.eoi_details.id);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  makePaymentRequests(type, ids, modal?, reason?) {
    let payload: any = {
      ids,
      type: type,
    };
    if (reason) payload.reason = reason;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.eoiService.makePaymentRequests(payload).subscribe(
      (res) => {
        swal("request made successfully", "", "success");
        this.getPaymentCollection(this.eoi_details.id);
        this.slimLoadingBarService.complete();
        if (modal) modal.close();
        if (reason) this.recall_request_reason = "";
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  approvePaymentRequest(ids, type?) {
    let payload: any = {
      ids,
    };
    if (type) payload.type = type;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.eoiService.approvePaymentRequest(payload).subscribe(
      (res) => {
        swal("approved successfully", "", "success");
        this.getPaymentCollection(this.eoi_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  rejectPaymentRequest(ids) {
    let payload: any = {
      ids,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.eoiService.rejectPaymentRequest(payload).subscribe(
      (res) => {
        swal("rejected successfully", "", "success");
        this.getPaymentCollection(this.eoi_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  onOpenUploadScannedCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  uploadScannedChequeSubmit(modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = Object.assign({}, this.uploadScannedChequeForm.value);
    console.log(formModel);
    if (!formModel.scannedCheque) {
      swal("Oops...", "Files can not be empty!", "error");
    } else {
      const data = {
        // receipt: formModel.receipt.value,
        // scan_url: formModel.signed.value,
        // id: reservationId,
        // file_name2: formModel.signed.filename,
        // file_name: formModel.receipt.filename,
        image_value: formModel.scannedCheque.value,
        image_name: formModel.scannedCheque.filename,
      };
      console.log(data);
      this.eoiService
        .uploadScannedCheque(this.current_active_cheque, data)
        .subscribe(
          (data) => {
            console.log(data);
            this.getEoi();
            this.getPaymentCollection(this.eoi_details.id);
            this.slimLoadingBarService.complete();
            modal.close();
            this.uploadScannedChequeForm.reset();
            swal("Woohoo!", "Contractor Approved!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  handleUploadScannedCheque(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        // this.filesForm.get("receipt").setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: (reader.result as any).split(",")[1],
        // });
        this.uploadScannedChequeForm.get("scannedCheque").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  deleteEoiDetails(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this EOI Details!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.eoiService.deleteEOIDetails(id).subscribe(
          (res: any) => {
            swal("Success", "EOI deleted successfully", "success");
            this.slimLoadingBarService.complete();
            this.getEoi();
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  editLeadModalModalOpen(eoiDetailsID) {
    this.eoi_details_id = eoiDetailsID;
    this.eoi_details.details.forEach((detail) => {
      if (detail.id == eoiDetailsID) {
        this.edit_eoi_details_data = {
          unit_type: detail.unit_type,
          unit_floor: detail.unit_floor,
          beds_number: detail.beds_number,
          has_nany_room: detail.has_nany_room,
          interested_area_from: detail.interested_area_from,
          interested_area_to: detail.interested_area_to,
          eoi_value: detail.eoi_value,
          design_type: detail.design_type,
          generic_type: detail.generic_type,
        };
      }
    });
  }

  changeLinkedReservationModal(eoiDetailsID) {
    this.eoi_details_id = eoiDetailsID;
  }

  changeLinkedReservationModalModalOpen(eoiDetailsID) {}

  editEOIDetailsModalSubmit(modal) {
    const payload = this.edit_eoi_details_data;
    this.slimLoadingBarService.start();
    this.eoiService.editEOIDetails(this.eoi_details_id, payload).subscribe(
      (res: any) => {
        this.getEoi();
        swal("Success", "EOI edited successfully", "success");
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  reservationObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}reservations/filter/unit?serial=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.reservationsArrSearch = [];
            this.reservationDataFromSearch = res.data;
            res.data.forEach((e) => {
              this.reservationsArrSearch.push(`${e.unit.serial} / ${e.id}`);
            });
            return this.reservationsArrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  changeLinkedReservationModalSubmit(id, modal) {
    if (this.chosenReservation) {
      const payload = {
        reservation_id: this.chosenReservation.split(" / ")[1],
      };
      this.slimLoadingBarService.start();
      this.eoiService.changeLinkedReservationEOI(id, payload).subscribe(
        (res) => {
          modal.close();
          this.chosenReservation = null;
          this.chosen_reservation = null;
          swal("Success", "Linked Reservation Successfully", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
    }
  }

  goToLinkedReservationSerial(reservation) {
    window.localStorage.setItem(
      "reservationDetails",
      JSON.stringify(reservation)
    );
    this.router.navigate(["/pages/project/view-reservation"]);
  }

  openRecallRequests(modal, ids) {
    this.recall_request_ids = ids;
    modal.open();
  }

  recallRequestSubmit(modal, type) {
    this.makePaymentRequests(
      "Recall Request",
      this.recall_request_ids,
      modal,
      this.recall_request_reason
    );
  }

  returnToAR(id) {
    const payload = {
      ids: [id],
    };
    this.slimLoadingBarService.start();
    this.eoiService.returnToAR(payload).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        this.getPaymentCollection(this.eoi_id);
        swal("Success", "Returned to AR Successfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  approvePendingCollect(payment) {
    swal({
      title: "Are you sure?",
      text: "You will approve this payment!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [payment.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.approvePendingCollected(payload).subscribe(
          (res: any) => {
            swal("Success", "Payment Approved Successfully!", "success");
            this.slimLoadingBarService.complete();
            this.getPaymentCollection(this.eoi_id);
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  rejectPendingCollect(payment) {
    swal({
      title: "Are you sure?",
      text: "You will reject this payment!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [payment.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.rejectPendingCollected(payload).subscribe(
          (res: any) => {
            swal("Success", "Payment Rejected Successfully!", "success");
            this.slimLoadingBarService.complete();
            this.getPaymentCollection(this.eoi_id);
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  downloadDocument(document, receipt) {
    console.log(document);
    console.log(this.eoi_details);
    swal("Print Design Not Available", "", "info");
    return;
    print_template(
      printRecipts,
      document,
      this.eoi_details,
      receipt
    );
  }


  changeChequeCollectType(event) {
    if (event === "fully-collected") {
      this.cheque_amount = this.active_cheque_book_row.amount;
    } else {
      this.cheque_amount = null;
    }
  }

  calculateEquvalentAmount() {
    if (
      this.currency_code != "EGP" &&
      this.exchange_rate &&
      this.cheque_amount
    ) {
      this.equivalent_in_currency = (this.cheque_amount / this.exchange_rate).toFixed(2);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/eois/eoi-view/eoi-view.component.ts